import React from "react";
import Immutable from "immutable";
import createReactClass from "create-react-class";
import PureRenderMixin from "react-addons-pure-render-mixin";
import getContainerDimensions from "react-dimensions";

import {Column, Row} from "js/common/views/foundation-column-layout";
import {TextButton} from "js/common/views/inputs/buttons";
import LoadingSpinner from "js/common/views/loading-spinner";
import ErrorMsg from "js/common/views/error";
import SuccessMsg from "js/common/views/success";
import GroupAndUserPicker from "js/common/views/inputs/group-and-user-picker/filterable-group-user-tree";
import SharedWithList from "js/common/views/sharing/shared-with-list";

export default getContainerDimensions()(createReactClass({

  mixins: [PureRenderMixin],

  render() {
    const {
      containerHeight,
      reportSharingSettings,
      hasReportSharingSettingsChanged,
      onCancelChangesRequest,
      onShareReportRequest,
      isLoading,
      shareReportError,
      shareReportSuccess,
      onSuccessTimeout
    } = this.props;
    const sectionHeaderHeight = 36;
    const buttonAndHeaderAreaHeight = 100;
    const height = containerHeight - buttonAndHeaderAreaHeight;
    const containerStyle = {
      height: height,
      maxHeight: height,
      overflow: "auto"
    };
    const buttonStyle = {
      marginRight: "0.5rem",
      marginLeft: "0.5rem"
    };
    return (
        <div style={{height: "100%", overflow: "hidden"}}>
          <Row>
            <Column small={12} medium={6} smallCentered={true}>
              <TextButton
                  testId="cancel-sharing-changes-btn"
                  icon="history"
                  label="Cancel"
                  onClick={onCancelChangesRequest}
                  disabled={!hasReportSharingSettingsChanged}
                  style={buttonStyle} />
              <TextButton
                  testId="save-sharing-changes-button"
                  icon="floppy-o"
                  type="primary"
                  label={isLoading ? "Saving" : "Save"}
                  onClick={onShareReportRequest}
                  disabled={!hasReportSharingSettingsChanged || isLoading}
                  style={buttonStyle} />
              <div style={{marginTop: "0.5rem"}}>
                {shareReportError && <ErrorMsg text={shareReportError} />}
                {shareReportSuccess &&
                    <SuccessMsg text={shareReportSuccess} onMessageTimeout={onSuccessTimeout} />}
              </div>
            </Column>
          </Row>
          {isLoading
              ? this.renderLoadingSpinner()
              : <Row style={{maxWidth: "100%", paddingTop: "1rem", paddingBottom: "1rem"}}>
                <Column small={12} medium={5}>
                  <div style={{height: sectionHeaderHeight}}>
                    Select users and groups
                  </div>
                  <div style={containerStyle}>
                    <GroupAndUserPicker
                        testId="share-user-search"
                        selectedGroupIds={reportSharingSettings.get("groupIds", Immutable.Set()).toSet()}
                        selectedUserIds={reportSharingSettings.get("userIds", Immutable.Set()).toSet()}
                        onGroupClick={this.handleGroupSelect}
                        onUserClick={this.handleUserSelect}
                        showInvisibleUsers={true}
                        expandAll={true}
                        customContainerStyle={{borderBottom: "none !important"}}
                        identifyObservers={true}
                        includeCube19Users={false}
                        includeInactiveUsers={false}
                        disableChildrenOfSelectedGroups={true} />
                  </div>
                </Column>
                <Column small={12} medium={7}>
                  <div style={{height: sectionHeaderHeight}}>
                    <i className="fa fa-share-square-o" style={{paddingRight: 8}} />
                    Shared with
                  </div>
                  <div style={containerStyle}>
                    {reportSharingSettings.isEmpty()
                        ? <LoadingSpinner />
                        : <SharedWithList
                            sharedWith={reportSharingSettings}
                            onGroupClick={this.handleGroupDeselect}
                            onUserClick={this.handleUserDeselect}
                            onUnshareWithAllClick={this.removeAllSelectedGroupsAndUsers} />}
                  </div>
                </Column>
              </Row>}
        </div>
    );
  },

  renderLoadingSpinner() {
    return (
        <div style={{marginTop: "1rem"}}>
          <LoadingSpinner label="Loading Report Sharing Settings" />
        </div>
    );
  },

  handleGroupSelect(groupId) {
    const {reportSharingSettings, onReportSharingSettingsChange} = this.props;
    const groupIds = reportSharingSettings.get("groupIds");
    onReportSharingSettingsChange(reportSharingSettings.set("groupIds", groupIds.add(groupId)));
  },

  handleUserSelect(userId) {
    const {reportSharingSettings, onReportSharingSettingsChange} = this.props;
    const userIds = reportSharingSettings.get("userIds");
    onReportSharingSettingsChange(reportSharingSettings.set("userIds", userIds.add(userId)));
  },

  handleGroupDeselect(groupId) {
    const {reportSharingSettings, onReportSharingSettingsChange} = this.props;
    const groupIds = reportSharingSettings.get("groupIds");
    onReportSharingSettingsChange(reportSharingSettings.set("groupIds", groupIds.delete(groupId)));
  },

  handleUserDeselect(userId) {
    const {reportSharingSettings, onReportSharingSettingsChange} = this.props;
    const userIds = reportSharingSettings.get("userIds");
    onReportSharingSettingsChange(reportSharingSettings.set("userIds", userIds.delete(userId)));
  },

  removeAllSelectedGroupsAndUsers() {
    const {reportSharingSettings, onReportSharingSettingsChange} = this.props;
    const newReportSharingSettings = reportSharingSettings
        .set("groupIds", reportSharingSettings.get("groupIds").clear())
        .set("userIds", reportSharingSettings.get("userIds").clear());
    onReportSharingSettingsChange(newReportSharingSettings);
  }

}));
